import { faSync } from "@fortawesome/pro-solid-svg-icons/faSync";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconRefresh: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <><MprcIconFa {...props} icon={faSync} />&nbsp;</>;
};
